import { render, staticRenderFns } from "./EditAcceptance.vue?vue&type=template&id=b22637a0"
import script from "./EditAcceptance.vue?vue&type=script&lang=js"
export * from "./EditAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports